import { ObstacleVersion, ObstacleCollisionArea, ObstacleShadow } from "../ObstacleVersion";
import { eModelAsset, eAtlas_0 } from "../../../../Game";
import { GameWorld } from "../../GameWorld";



export class HammerObsVer extends ObstacleVersion {
    /**
     * (RO) Jak dlouho trva prevraceni kladiva z jedne strany na druhou ve vterinach
     */
    get flipTime(): number { return this._flipTime; }
    private _flipTime: number;

    /**
     * (RO) Prodleva pred prevracenim kladiva ve vterinach
     */
    get flipDelay(): number { return this._flipDelay; }
    private _flipDelay: number;

    /**
     * (RO) Ease funkce pro flip
     */
    get flipEase(): ((k: number) => number) { return this._flipEase; }
    private _flipEase: ((k: number) => number);

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(flipTime: number, flipDelay: number, flipEase: (k: number) => number) {
        super(0,
            eModelAsset.pillar_0,
            0,
            [
                // Sloupek
                new ObstacleCollisionArea(new pc.BoundingBox(new pc.Vec3(0, 0.4, 0), new pc.Vec3(0.2, 0.4, 0.2))),
                // Hlava kladiva
                new ObstacleCollisionArea(new pc.BoundingSphere(new pc.Vec3(1, 0, 0), 0.35))
            ],
            new pc.Vec3(1.35, 1, 0.35),
            new ObstacleShadow(eAtlas_0.shadowSquare, 0.6, 0.6, 0, GameWorld.SHADOW_Y, 0, true));

        this._flipTime = flipTime;
        this._flipDelay = flipDelay;
        this._flipEase = flipEase;
    }
}